(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('.site-header__hamburger');
    var drawer = document.getElementById('mobile-nav');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      drawer.setAttribute('aria-hidden', !open);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
